import styles from "./StepTemplate.module.scss";
import { Typography } from 'seagull';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function StepTemplate(props) {
  const {
    currentStep,
    stepper,
    header,
    subHeader,
    children,
    footer
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": "vob-step-".concat(currentStep),
    className: styles.root,
    children: [stepper ? /*#__PURE__*/_jsx("div", {
      "data-testid": "vob-step-".concat(currentStep, "-stepper"),
      className: styles.step,
      children: /*#__PURE__*/_jsx(Typography, {
        children: stepper
      })
    }) : null, /*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h3",
        children: header
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        weight: "light",
        skin: "secondary",
        children: subHeader
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [children, /*#__PURE__*/_jsx("div", {
        className: styles.footer,
        children: footer
      })]
    })]
  });
}